import React from 'react';

const Section = ({ sectionTitle, title, spanTitle, description, image }) => {
  return (
    <section className="bg-slate-100 dark:bg-gray-950 py-6">
      <div className="container mx-auto flex flex-col lg:flex-row items-center px-6 lg:px-20">
        {/* Texte de gauche */}
        <div className="lg:w-1/2 text-center lg:text-left mb-10 lg:mb-0 mr-6">
          <h6 className="text-xl font-bold text-blue-600 mb-4">{sectionTitle}</h6>
          <h1 className="text-5xl font-bold text-gray-800 dark:text-gray-200 mb-4">
            {title} <span className="text-blue-600">{spanTitle}</span>
          </h1>
          <p className="text-gray-600 dark:text-gray-400 text-lg mb-6">
            {description}
          </p>
        </div>

        {/* Image à droite */}
        <div className="lg:w-1/2 w-full h-auto">
          <img
            src={image}
            alt={sectionTitle}
            className="w-full h-auto object-contain rounded-lg shadow-md"
          />
        </div>
      </div>
    </section>
  );
};

export default Section;
